import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import ApiService from "../../../src/apiService";

export default class ModalAlergi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patient_id: this.props.patient.patient_id,
            explanation: "-",
            detail_id: this.props.detail[0].id,
            details: this.props.detail
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    addAllergy = async e => {
        let res = await ApiService.post('registration/allergies/create', {
            patient_id: this.state.patient_id,
            explanation: this.state.explanation,
            detail_id: this.state.detail_id
        });
        if (res.code === 200) {
            if (res.code === 200) {
                setTimeout(
                    function () {
                        this.props.parentCallback(res.data);
                    }.bind(this),
                    200
                );
                this.props.onHide();
            } else {
                console.log(res.code);
            }
        }
    }

    render() {
        const allergy_detail = this.state.details.map(details => {
            return (
                <option value={details.id}>{details.name}</option>
            )
        });
        return (
            <Modal {...this.props} aria-labelledby="modal-alergi">
                <ModalHeader closeButton>
                    <ModalTitle id="modal-alergi">Tambah Data Alergi</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label>Jenis Alergi</label>
                                <select
                                    name='detail_id'
                                    className='form-control'
                                    onChange={this.handleChange}
                                >
                                    {allergy_detail}
                                </select>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <label>Detail Alergi</label>
                                <input
                                    className='form-control'
                                    name='explanation'
                                    placeholder='Detail Alergi'
                                    type='text'
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="row">
                        <div className="col-12">
                            <button
                                type="button"
                                onClick={this.props.onHide}
                                className="btn btn-outline-secondary"
                            >
                                Batal
                            </button>
                            <button type="button" className="btn btn-primary"
                                onClick={this.addAllergy}
                            >
                                Simpan Alergi Pasien
                            </button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}
